import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LoginUiContainerComponent } from '../../login-ui-container/login-ui-container.component';
import { CANCEL, SELECT_DATABASE_NEW } from '../../../shared/strings';
import { ChangeDatabaseComponent } from '../../change-database/change-database.component';
import { MatDialogRef } from '@angular/material/dialog';
import { ConnectDatabaseFunction } from '../../../types/ConnectDatabaseFunction';
import { DataService } from '../../../interfaces/DataService';

@Component({
  selector: 'app-change-database-dialog',
  standalone: true,
  imports: [
    CommonModule,
    LoginUiContainerComponent,
    ChangeDatabaseComponent
  ],
  templateUrl: './change-database-dialog.component.html',
  styleUrl: './change-database-dialog.component.scss'
})
export class ChangeDatabaseDialogComponent {
  CANCEL = CANCEL;
  SELECT_DATABASE_NEW = SELECT_DATABASE_NEW;

  private readonly dialogRef = inject(MatDialogRef<ChangeDatabaseDialogComponent>, { optional: true });

  showDialog =()=>{return true}
  connectToDatabase: ConnectDatabaseFunction = (data_service: DataService)=>{
    this.dialogRef?.close(data_service);
  }

  onCancel = ()=>{
    this.dialogRef?.close();
  }
}
